module.exports = __webpack_public_path__ + "static/media/familia-premium_tintas.37cd2eb9.webp";